'use client';
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { HOTEL_AVAILABILITY_BB_QUERY, HOTEL_AVAILABILITY_CCUI_QUERY, HOTEL_AVAILABILITY_QUERY, RATE_INFORMATION_BB_QUERY, RATE_INFORMATION_CCUI_QUERY, BOOKING_SUBCHANNEL, PROMO_CODE_COOKIE, RatePlanCodes, HOTEL_AVAILABILITY_DISCOUNT_RATE_QUERY, DISCOUNT_RATE_INFORMATION_QUERY } from '@whitbread-eos/api';
import { getHotelAvailabilityQueryKey } from '../getters';
import { getLoggedInUserInfo } from '../getters/auth';
import { getCookie } from '../helpers/cookies';
import useCustomLocale from './use-custom-locale';
import { useQueryRequest } from './use-request';
export function useHotelAvailability(hotelId, hotelBrand, arrival, departure, rooms, channel, empOfferCodes, accessToken, landingPromoCode, promoKind, softBundle, rateName, roomClass, isPromoBox) {
  var _useCustomLocale = useCustomLocale(),
    country = _useCustomLocale.country,
    language = _useCustomLocale.language;
  var queryEnabled = arrival !== undefined && departure !== undefined;
  var _useQueryRequest = useQueryRequest(getHotelAvailabilityQueryKey(language, country, hotelBrand, hotelId, arrival, departure, rooms, empOfferCodes, landingPromoCode, promoKind, softBundle, rateName, roomClass, isPromoBox), HOTEL_AVAILABILITY_QUERY, {
      hotelId,
      arrival,
      departure,
      rooms,
      brand: hotelBrand === null || hotelBrand === void 0 ? void 0 : hotelBrand.toLowerCase(),
      language,
      country,
      bookingChannel: {
        channel,
        language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
        subchannel: BOOKING_SUBCHANNEL.WEB
      },
      channel,
      ratePlanCodes: empOfferCodes,
      promotionCode: landingPromoCode || getCookie(PROMO_CODE_COOKIE),
      promoKind: promoKind,
      softBundle,
      rateName,
      roomClass,
      isPromoBox
    }, _objectSpread({
      enabled: !!queryEnabled
    }, isPromoBox && {
      placeholderData: previousData => previousData
    }), accessToken),
    isLoading = _useQueryRequest.isLoading,
    isFetching = _useQueryRequest.isFetching,
    isError = _useQueryRequest.isError,
    data = _useQueryRequest.data,
    error = _useQueryRequest.error;
  return {
    isLoading,
    isFetching,
    isError,
    data,
    error
  };
}
export function useHotelAvailabilityBB(hotelId, hotelBrand, arrival, departure, rooms, channel, accessToken, landingPromoCode, promoKind, rateName, roomClass, isPromoBox) {
  var _userData, _data$hotelAvailabili;
  var userData = {
    profile: {
      accessLevel: '',
      companyId: '',
      employeeId: '',
      isBusiness: '',
      sessionId: ''
    },
    operaCompanyId: ''
  };
  if (accessToken) userData = getLoggedInUserInfo(accessToken);
  var companyId = (_userData = userData) === null || _userData === void 0 ? void 0 : _userData.operaCompanyId;
  var _useCustomLocale2 = useCustomLocale(),
    country = _useCustomLocale2.country,
    language = _useCustomLocale2.language;
  var queryEnabled = arrival !== undefined && departure !== undefined;
  var _useQueryRequest2 = useQueryRequest(['hotelAvailabilityBB', language, country, hotelBrand.toLowerCase(), hotelId, companyId, arrival, departure, JSON.stringify(rooms), channel, landingPromoCode, promoKind, rateName, roomClass, isPromoBox], HOTEL_AVAILABILITY_BB_QUERY, {
      hotelId,
      arrival,
      departure,
      rooms,
      brand: hotelBrand.toLowerCase(),
      language,
      country,
      companyId,
      bookingChannel: {
        channel: channel,
        language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
        subchannel: BOOKING_SUBCHANNEL.WEB
      },
      promotionCode: landingPromoCode,
      promoKind: promoKind,
      rateName,
      roomClass,
      isPromoBox
    }, _objectSpread({
      enabled: !!queryEnabled
    }, isPromoBox && {
      placeholderData: previousData => previousData
    }), accessToken),
    data = _useQueryRequest2.data,
    isLoading = _useQueryRequest2.isLoading,
    isFetching = _useQueryRequest2.isFetching,
    isError = _useQueryRequest2.isError,
    error = _useQueryRequest2.error;
  var roomRates = data === null || data === void 0 || (_data$hotelAvailabili = data.hotelAvailability) === null || _data$hotelAvailabili === void 0 ? void 0 : _data$hotelAvailabili.roomRates;
  if ((roomRates === null || roomRates === void 0 ? void 0 : roomRates.length) > 0) {
    var filteredRatePlanCodes = getFilteredRatePlans(roomRates);
    var filteredRoomRates = roomRates.filter(_ref => {
      var ratePlanCode = _ref.ratePlanCode;
      return filteredRatePlanCodes.includes(ratePlanCode);
    });
    data.hotelAvailability.roomRates = filteredRoomRates;
  }
  return {
    isLoading,
    isFetching,
    isError,
    data,
    error
  };
}
export function useHotelAvailabilityCCUI(hotelId, hotelBrand, arrival, departure, rooms, channel, queryEnabled, companyId, ccuiLandingPromoCode, promoKind, rateName, roomClass, isPromoBox) {
  var _data$hotelAvailabili2;
  var _useCustomLocale3 = useCustomLocale(),
    country = _useCustomLocale3.country,
    language = _useCustomLocale3.language;
  var _useQueryRequest3 = useQueryRequest(['hotelAvailabilityCCUI', language, country, hotelBrand.toLowerCase(), hotelId, companyId, arrival, departure, JSON.stringify(rooms), channel, ccuiLandingPromoCode, promoKind, rateName, roomClass, isPromoBox].filter(Boolean), HOTEL_AVAILABILITY_CCUI_QUERY, {
      hotelId,
      arrival,
      departure,
      rooms,
      brand: hotelBrand.toLowerCase(),
      language,
      country,
      companyId,
      bookingChannel: {
        channel: channel,
        language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
        subchannel: BOOKING_SUBCHANNEL.WEB
      },
      promotionCode: ccuiLandingPromoCode,
      promoKind: promoKind,
      rateName,
      roomClass,
      isPromoBox
    }, _objectSpread({
      enabled: !!queryEnabled
    }, isPromoBox && {
      placeholderData: previousData => previousData
    })),
    data = _useQueryRequest3.data,
    isLoading = _useQueryRequest3.isLoading,
    isFetching = _useQueryRequest3.isFetching,
    isError = _useQueryRequest3.isError,
    error = _useQueryRequest3.error;
  if (data !== null && data !== void 0 && (_data$hotelAvailabili2 = data.hotelAvailability) !== null && _data$hotelAvailabili2 !== void 0 && _data$hotelAvailabili2.roomRates) {
    data.hotelAvailability.roomRates = data.hotelAvailability.roomRates.filter(rate => rate.ratePlanCode !== RatePlanCodes.BUSIFLEX);
  }
  return {
    isLoading,
    isFetching,
    isError,
    data,
    error
  };
}
export function useHotelRatesInformationBB(hotelId, hotelBrand, dataHotelAvailability, channel, accessToken) {
  var _dataHotelAvailabilit;
  var _useCustomLocale4 = useCustomLocale(),
    country = _useCustomLocale4.country,
    language = _useCustomLocale4.language;
  var ratePlanCodes = dataHotelAvailability === null || dataHotelAvailability === void 0 || (_dataHotelAvailabilit = dataHotelAvailability.hotelAvailability) === null || _dataHotelAvailabilit === void 0 ? void 0 : _dataHotelAvailabilit.roomRates.map(roomRate => roomRate.ratePlanCode);
  var _useQueryRequest4 = useQueryRequest(['ratesInformationBB', language, country, hotelBrand.toLowerCase(), hotelId, channel, ratePlanCodes], RATE_INFORMATION_BB_QUERY, {
      hotelId,
      brand: hotelBrand === null || hotelBrand === void 0 ? void 0 : hotelBrand.toLowerCase(),
      language,
      country,
      channel,
      ratePlans: ratePlanCodes === null || ratePlanCodes === void 0 ? void 0 : ratePlanCodes.toString()
    }, undefined, accessToken),
    dataRatesInformation = _useQueryRequest4.data,
    isLoading = _useQueryRequest4.isLoading,
    isError = _useQueryRequest4.isError,
    error = _useQueryRequest4.error;
  var hotelData = _objectSpread(_objectSpread({}, dataHotelAvailability), dataRatesInformation);
  return {
    isLoading,
    isError,
    data: hotelData,
    error
  };
}
export function useHotelRatesInformationCCUI(hotelId, hotelBrand, dataHotelAvailability, channel, queryEnabled) {
  var _dataHotelAvailabilit2;
  var _useCustomLocale5 = useCustomLocale(),
    country = _useCustomLocale5.country,
    language = _useCustomLocale5.language;
  var ratePlanCodes = dataHotelAvailability === null || dataHotelAvailability === void 0 || (_dataHotelAvailabilit2 = dataHotelAvailability.hotelAvailability) === null || _dataHotelAvailabilit2 === void 0 ? void 0 : _dataHotelAvailabilit2.roomRates.map(roomRate => roomRate.ratePlanCode);
  var _useQueryRequest5 = useQueryRequest(['ratesInformationCCUI', language, country, hotelBrand.toLowerCase(), hotelId, channel, ratePlanCodes], RATE_INFORMATION_CCUI_QUERY, {
      hotelId,
      brand: hotelBrand === null || hotelBrand === void 0 ? void 0 : hotelBrand.toLowerCase(),
      language,
      country,
      channel,
      ratePlans: ratePlanCodes === null || ratePlanCodes === void 0 ? void 0 : ratePlanCodes.toString()
    }, {
      enabled: queryEnabled
    }),
    dataRatesInformation = _useQueryRequest5.data,
    isLoading = _useQueryRequest5.isLoading,
    isError = _useQueryRequest5.isError,
    error = _useQueryRequest5.error;
  var hotelData = _objectSpread(_objectSpread({}, dataHotelAvailability), dataRatesInformation);
  return {
    isLoading,
    isError,
    data: hotelData,
    error
  };
}
var getFilteredRatePlans = roomRates => {
  var ratePlanCodes = roomRates.map(roomRate => roomRate.ratePlanCode);
  var isHavingBusAndFlexRate = Array.isArray(ratePlanCodes) && ratePlanCodes.indexOf(RatePlanCodes.BUSIFLEX) > -1 && ratePlanCodes.indexOf(RatePlanCodes.FLEXRATE) > -1;
  return isHavingBusAndFlexRate ? ratePlanCodes.filter(planCode => planCode !== RatePlanCodes.FLEXRATE) : ratePlanCodes;
};
function getRatePlanCodes(dataHotelAvailability) {
  var _dataHotelAvailabilit3;
  return dataHotelAvailability === null || dataHotelAvailability === void 0 || (_dataHotelAvailabilit3 = dataHotelAvailability.hotelAvailability) === null || _dataHotelAvailabilit3 === void 0 ? void 0 : _dataHotelAvailabilit3.roomRates.map(roomRate => roomRate.ratePlanCode);
}
export function useHotelRatesInformationDiscountRate(hotelId, hotelBrand, dataHotelAvailability, channel, queryEnabled) {
  var _useCustomLocale6 = useCustomLocale(),
    country = _useCustomLocale6.country,
    language = _useCustomLocale6.language;
  var ratePlanCodes = getRatePlanCodes(dataHotelAvailability);
  var _useQueryRequest6 = useQueryRequest(['ratesInformationDiscountRate', language, country, hotelBrand.toLowerCase(), hotelId, channel, ratePlanCodes], DISCOUNT_RATE_INFORMATION_QUERY, {
      hotelId,
      brand: hotelBrand.toLowerCase(),
      language,
      country,
      channel,
      ratePlans: ratePlanCodes === null || ratePlanCodes === void 0 ? void 0 : ratePlanCodes.toString()
    }, {
      enabled: queryEnabled
    }),
    dataRatesInformation = _useQueryRequest6.data,
    isLoading = _useQueryRequest6.isLoading,
    isError = _useQueryRequest6.isError,
    error = _useQueryRequest6.error;
  var hotelData = _objectSpread(_objectSpread({}, dataHotelAvailability), dataRatesInformation);
  return {
    isLoading,
    isError,
    data: hotelData,
    error
  };
}
export function useHotelAvailabilityDiscountRate(_ref2) {
  var hotelId = _ref2.hotelId,
    hotelBrand = _ref2.hotelBrand,
    arrival = _ref2.arrival,
    departure = _ref2.departure,
    rooms = _ref2.rooms,
    channel = _ref2.channel,
    queryEnabled = _ref2.queryEnabled,
    companyId = _ref2.companyId;
  var _useCustomLocale7 = useCustomLocale(),
    country = _useCustomLocale7.country,
    language = _useCustomLocale7.language;
  var queryParams = {
    hotelId,
    arrival,
    departure,
    rooms,
    brand: hotelBrand.toLowerCase(),
    language,
    country,
    companyId,
    bookingChannel: {
      channel: channel,
      language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
      subchannel: BOOKING_SUBCHANNEL.WEB
    }
  };
  var _useQueryRequest7 = useQueryRequest(['hotelAvailabilityDiscountRate', language, country, hotelBrand.toLowerCase(), hotelId, companyId, arrival, departure, JSON.stringify(rooms), channel], HOTEL_AVAILABILITY_DISCOUNT_RATE_QUERY, queryParams, {
      enabled: queryEnabled
    }),
    data = _useQueryRequest7.data,
    isLoading = _useQueryRequest7.isLoading,
    isError = _useQueryRequest7.isError,
    error = _useQueryRequest7.error;
  return {
    isLoading,
    isError,
    data,
    error
  };
}